module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Tableau Exp-Réa AD PED (Version 2).fb809e5e6d8a55096d06f487476cbcad.pdf";